import React, { useState, useEffect } from "react";
import Main from "../components/Main";
import Clients from "../components/Clients";

import Footer from "../components/Footer";
import Showreel from "../components/Showreel";
import ServiceSection from "../components/ServiceSection";
import Testimonials from "../components/Testimonials";
import AboutPage from "../components/AboutSection";
import ContactPage from "../components/ContactForm";

function Home() {
  // State to control the popup visibility

  return (
    <div className="">
      <Main />
      <Showreel />
      <div className="h-[80vh]"></div>
      <AboutPage />
      <ServiceSection />
      <Testimonials />
      <ContactPage />
    </div>
  );
}

export default Home;
